import { Component, Inject, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseImageViewer } from 'src/app/shared/classes/base-image-viewer';
import { CarouselViewerVM, ImageInPreviewVM } from 'src/app/shared/interfaces/image-viewer.interface';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { FireStorageService } from '../../services/storage.service';

@Component({
  selector: 'app-image-carousel-viewer',
  templateUrl: './image-carousel-viewer.component.html',
  styleUrls: ['./image-carousel-viewer.component.scss']
})
export class ImageCarouselViewerComponent extends BaseImageViewer {
  public currentImageUrl = '';
  public index = 0;
  public images: ImageInPreviewVM[] = [];

  private imageCache = new Map<string, string>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CarouselViewerVM,
    ctxDS: ContextDataService,
    storageService: FireStorageService,
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) document: Document
  ) {
    super(ctxDS, storageService, rendererFactory, document);
    this.index = this.data.idx;
    this.images = this.data.images;
    this.resolveUrl();
  }

  public get currentImage(): ImageInPreviewVM {
    return this.images[this.index];
  }

  public get isDefectDetailsView(): boolean {
    return this.data.layout === 'defect-details';
  }

  public back(): void {
    if (--this.index < 0) this.index = this.images.length - 1;
    this.resolveUrl();
  }

  public forward(): void {
    this.index = ++this.index % this.images.length;
    this.resolveUrl();
  }

  public toggleOriginal(): void {
    if (this.currentImage.originalPath) {
      const p = this.currentImage.path;
      this.currentImage.path = this.currentImage.originalPath;
      this.currentImage.originalPath = p;
      this.currentImage.showOriginal = !this.currentImage.showOriginal;
      this.resolveUrl();
    }
  }

  public async resolveUrl(): Promise<void> {
    if (!this.currentImage) {
      return;
    }
    if (this.currentImage?.rawData) {
      this.currentImageUrl = this.currentImage.rawData;
      return;
    }
    if (this.imageCache.has(this.currentImage.path)) {
      this.currentImageUrl = this.imageCache.get(this.currentImage.path)!;
      return;
    }
    const url = await this.storageService.getDownloadURL(this.currentImage.path);
    this.imageCache.set(this.currentImage.path, url);
    this.currentImageUrl = url;
  }
}
